import { useTranslation } from 'react-i18next';

interface MissingIntegrationNoticeProps {
  i18nNamespace: string;
}

export function MissingIntegrationNotice({ i18nNamespace }: MissingIntegrationNoticeProps) {
  const { t } = useTranslation();

  return (
    <div className="mt-4 flex flex-col gap-2 rounded-lg border border-warning/20 bg-warning/10 p-4">
      <div className="text-warning-foreground text-sm font-medium">
        {t(`${i18nNamespace}:duplicates.missingIntegration`)}
      </div>
      <div className="text-warning-foreground/80 text-xs">
        {t(`${i18nNamespace}:duplicates.missingIntegrationNotice`)}
      </div>
      <div className="text-warning-foreground/80 text-xs">
        {t(`${i18nNamespace}:duplicates.missingIntegrationNotice2`)}
      </div>
    </div>
  );
}
